/**
 * Modifications for grouped products on the product page.
 */
(() => {
    /**
     * Set quantity of all grouped products to 1 on page load.
     */
    document
        .querySelectorAll(
            '.woocommerce-grouped-product-list .quantity input[type=number]'
        )
        .forEach((input) => {
            input.value = 1;
        });
})();
